import React, { useCallback } from 'react';
import styled from 'styled-components';
import * as styles from './styles';
import { PinCodeFooterProps } from './models';
import useTimer from '@sunbit-dev/purchase-common/src/hooks/useTimer';
import { useTranslation } from '@sunbit-dev/translations';
import { StyledLink } from '@sunbit-dev/web-ui-lib';
import classNames from 'classnames';
import { getTime } from '@sunbit-dev/purchase-common/src/utilities/time';

const baseDuration = 60;

export const PinCodeFooter = styled(({ className, onResendClick }: PinCodeFooterProps) => {
  const { t } = useTranslation('landing_page', { keyPrefix: 'pin_code_view.pin_code_footer' });
  const { countDown } = useTimer(baseDuration);

  return (
    <div className={className}>
      <StyledLink
        onClick={onResendClick}
        className={classNames('resend-verification-link', { disabled: countDown > 0 })}
      >
        {t('link')}
      </StyledLink>
      <span className="resend-timer">{countDown ? ` (${getTime(countDown)})` : '(0:00)'}</span>
    </div>
  );
})`
  ${styles.PinCodeFooter}
`;
